import React from "react";

import pungyasaraThero from "../../assests/history/pungyasara_thero.webp";
import woodwardAmarasooriya from "../../assests/history/woodward_amarasooriya.webp";
import founderPrincipal from "../../assests/history/founder_principal.webp";

export default function SchoolHistoryComponent() {
  const historyData = {
    images: [
      {
        src: pungyasaraThero,
        alt: "Most Venerable Welivitiye Pungyasara Thero",
        caption:
          "Most Venerable Welivitiye Pungyasara Thero, Founder of Vidyaloka College",
      },
      {
        src: woodwardAmarasooriya,
        alt: "Mr. Henry Woodward Amarasuriya",
        caption:
          "Mr. Henry Woodward Amarasuriya, Founding Administrator of Vidyaloka College",
      },
      {
        src: founderPrincipal,
        alt: "Mr. E. A. Munasinghe",
        caption:
          "Mr. E. A. Munasinghe, Founding Principal of Vidyaloka College",
      },
    ],
  };

  return (
    <section
      className="mb-5"
      style={{ backgroundColor: "#fff" }}
      data-aos="fade-left"
      id="history"
    >
      <div className="rounded-3 border-vcg-muted p-4">
        <h3 className="fw-bold mb-4">History of Vidyaloka College</h3>

        <div className="row align-items-start">
          {/* History Text */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <p className="text-secondary mb-3" style={{ textAlign: "justify" }}>
              Vidyaloka College was established on 14 January 1941 by Most
              Venerable Welivitiye Pungyasara Thero and Mr. Henry Woodward
              Amarasuriya with the noble purpose of providing English education
              to underprivileged children in the Galle area.
              <br />
              <br />
              During the early years of the school, prior to its acquisition by
              the government, Mr. Henry Woodward Amarasuriya personally managed
              the administration of the institution. He devoted his own
              financial resources to ensure the smooth functioning, growth, and
              sustainability of the school. His selfless commitment played a
              crucial role in laying a strong foundation for Vidyaloka College
              and securing its future as a respected educational institution.
              <br />
              <br />
              The first student registered under Registration Number 1 at
              Vidyaloka College was the late Venerable Kahaduwe Chandrajothi
              Thero, followed by renowned late Professor C. Dahanayaka as the
              second registered student. On the opening day of the school, a
              total of 42 students were enrolled.
              <br />
              <br />
              The first Principal of Vidyaloka College, Mr. E. A. Munasinghe,
              provided strong leadership during the school’s formative years and
              played a vital role in establishing its academic foundations. In
              November 1944, he was suddenly transferred to another school by
              the authorities. This decision sparked an unprecedented response
              from the students, who organized a large scale protest and refused
              to attend classes in opposition to the transfer. This incident is
              widely recognized as the first recorded student protest of its
              kind in the history of Sri Lankan schools, highlighting the deep
              respect and admiration students held for their principal and the
              strong sense of unity within the Vidyaloka College community.
            </p>
          </div>

          {/* History Images */}
          <div className="col-lg-6">
            {/* First row – first two images */}
            <div className="row g-4 justify-content-center mb-3">
              {historyData.images.slice(0, 2).map((image, index) => (
                <div
                  key={index}
                  className="col-12 col-sm-6 d-flex flex-column align-items-center"
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="img-fluid rounded-3"
                    style={{
                      width: "250px",
                      height: "250px",
                      aspectRatio: "1/1",
                      objectFit: "cover",
                    }}
                  />
                  {image.caption && (
                    <p className="text-center text-muted mt-2 small">
                      {image.caption}
                    </p>
                  )}
                </div>
              ))}
            </div>

            {/* Second row – last image centered */}
            <div className="row g-4 justify-content-center">
              {historyData.images.slice(2, 3).map((image, index) => (
                <div
                  key={index}
                  className="col-12 col-sm-6 d-flex flex-column align-items-center"
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="img-fluid rounded-3"
                    style={{
                      width: "250px",
                      height: "250px",
                      aspectRatio: "1/1",
                      objectFit: "cover",
                    }}
                  />
                  {image.caption && (
                    <p className="text-center text-muted mt-2 small">
                      {image.caption}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
